import React from "react";
import './competition_section.css';
import CompetitionCard from './Cards/competition_section_card'
// reactstrap components
import {
    Button,
    CardImg,
    CardText,
    CardSubtitle,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    FormGroup,
    Input,
    Container,
    Col,
    Row
} from "reactstrap";

class Competition extends React.Component {
    constructor(props) {
        super(props);
        }

    render() {
        return (
            <section id="competitions" className="competition fullpage-section" style={{paddingTop: '15vh'}}>
                <Container>
                    <h1 className='mainhead'>COMPETITION PARTICIPATION</h1>
                    <img className='svgred2'  src={require("./../../assets/img/Rectangle 4.svg")} />
                    <img className='line2' src={require("./../../assets/img/Rectangle 6.svg")} />
                    <div className="bgtext2">TEAM ANTRIKSH</div>
                    <div className="competition-card-container">
                        <div className="comp-card">
                            <div className="comp-image">
                                <iframe id="youtube-desktop" width="450" height="315" src="https://www.youtube.com/embed/eIp8vpdjSPg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                <iframe id="youtube-phone" width="350" height="215" src="https://www.youtube.com/embed/eIp8vpdjSPg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

                            </div>
                            <div className="comp-title">University Rover Challenge, 2020</div>
                        </div>

                        <div className="comp-card">
                            <div className="comp-image" id="erc-cover">T</div>
                            <div className="comp-title">Europen Rover Challenge, 2020 (ONGOING)</div>
                        </div>
                    </div>
                    
                    
                </Container>
            </section>
        );
    }
}

export default Competition;
